




















































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { SettingsVue } from "fs-pb-vue2/vueModels/settings/SettingsVue";
import ShortCodeSetModal from "./ShortCodeSetModal.vue";

@Component({ components: { ShortCodeSetModal } })
export default class PinEditModal extends SettingsVue {

  shortCodeOn: boolean = false;

  dialogContent: any = {};

  dialogTransfer: boolean = false;

  dialogLoginSettings: boolean = false;

  mounted(): void {
    this.shortCodeOn = window.localStorage.getItem('loginWithoutPasswordOn') === "1";
  }

  updated(): void {
    this.shortCodeOn = window.localStorage.getItem('loginWithoutPasswordOn') === "1";
  }

  shortCodeOnAction() {
    if (!this.shortCodeOn) {
      window.localStorage.setItem('loginWithoutPasswordOn', undefined);
    } else {
      this.dialogContent = new Object({
        vueName: "ShortCodeSetModal",
      });
      this.dialogLoginSettings = true;
    }
  }

  get deviceGUID(): string {
    return window.localStorage.getItem(this.personStore.personInfo.Data.Login);
  }

}
